import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dropdown-menu relative flex flex-col items-center gap-4 min-w-52 h-auto pt-2"
}
const _hoisted_2 = { class: "dropdown-text text-lg" }

import { computed, ref } from 'vue';
interface Props {
    title: string;
    options: Record<string,  string>;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'MobileNavDropdown',
  props: {
    title: {},
    options: {}
  },
  emits: ["close-menu"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;


const opened = ref(false);
const dropdownOptions = computed(() => Object.entries(props.options));

const closeMenu = (): void => {
    emit('close-menu');
    opened.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: "relative flex flex-col items-center h-full",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (opened.value = !opened.value), ["stop"]))
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["link text-2xl", { 'mb-4': opened.value }])
    }, _toDisplayString(props.title) + " ▼", 3),
    _createVNode(_Transition, { name: "mobile-dropdown" }, {
      default: _withCtx(() => [
        (opened.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dropdownOptions.value, ([pageTitle, pageLink], index) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: pageLink,
                  to: pageLink,
                  class: "dropdown-item cursor-pointer w-auto text-center text-[#f0f7f2] py-1",
                  style: _normalizeStyle({ '--drop-index': index }),
                  onClick: closeMenu
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(pageTitle), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "style"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})